import type { Route } from '@/types';
import {
  getRouteName,
  getCellStyle,
  getImageUrl,
  getImageSize,
  hasAlerts,
} from '../../utils/routeHelpers';
import {
  hasShownDepartureInItinerary,
  getDisplayDepartures,
} from '../../utils/departureHelpers';
import { DepartureTime, InactiveDeparture } from './DepartureTime';

interface RouteCardFrontProps {
  route: Route;
  isWhite?: boolean;
}

export function RouteCardFront({ route, isWhite }: RouteCardFrontProps) {
  const routeName = getRouteName(route);
  const imageUrl = getImageUrl(route, 2);
  const imageSize = getImageSize(route);
  const showAlerts = hasAlerts(route);

  return (
    <div className="flip-card-front">
      {showAlerts && (
        <div className="alert-count">{route.alerts?.length}</div>
      )}

      <h2>
        <span>
          {routeName}
          {route.route_short_name && (
            <i>{route.route_short_name !== routeName ? '' : ''}</i>
          )}
        </span>
        {imageUrl && (
          <img
            className={imageSize === 28 ? 'img28' : 'img34'}
            src={imageUrl}
            alt=""
          />
        )}
        {showAlerts && (
          <i className="alert-icon" title={route.alerts?.[0]?.title}>
            ⚠️
          </i>
        )}
      </h2>

      {route.itineraries.map((itinerary, index) => (
        <div key={index} className="route-content">
          <div className="stop-name">
            <strong>Board at: </strong>
            {itinerary.closest_stop.stop_name}
          </div>
          <div className="direction" style={getCellStyle(route)}>
            <h3>{itinerary.merged_headsign}</h3>

            {hasShownDepartureInItinerary(itinerary) && (
              <div className="time-display">
                {getDisplayDepartures(itinerary, 3).map((item, idx) => (
                  <DepartureTime key={idx} item={item} isWhite={isWhite} />
                ))}
                {/* Fill remaining slots with inactive placeholders */}
                {Array.from({
                  length: Math.max(0, 3 - getDisplayDepartures(itinerary, 3).length),
                }).map((_, idx) => (
                  <InactiveDeparture key={`inactive-${idx}`} isWhite={isWhite} />
                ))}
              </div>
            )}
          </div>
        </div>
      ))}
    </div>
  );
}
